export const HOME = '/'
export const MENU = '//merchant/:merchantId'
export const CART = '/cart'
export const ORDER = '/order'